<template>
  <div class="page-content-pc">
    <div class="banner">
      <div class="introduce">
        <div class="introduce_title">
          产品定价
        </div>
        <div class="introduce_desc">
          <div>可根据您的企业规模和需求，选择不同的产品、版本和部署方式</div>
        </div>
      </div>
    </div>

    <!-- 版本板块 -->
    <div class="version-box">
      <div class="version-card" v-for="(item, idx) in versionList" :key="idx" :class="item.className" :style="{
        backgroundImage: `url(${item.img})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 0 top 0',
        backgroundSize: '100% 100%'
      }">
        <div class="version-card-desc" :style="{ color: item.descColor }">{{ item.desc }}</div>
        <div class="version-card-bottom">
          <div class="version-card-info" :style="{ background: item.infoBg }">
            <div class="version-card-info-item">
              <img :src="item.robotIcon" class="version-card-info-icon" alt="机器人" />
              <span>{{ item.robot }}</span>
            </div>
            <div class="version-card-info-item">
              <img :src="fireIcon" class="version-card-info-icon" alt="对话条数" />
              <span class="version-card-info-text">{{ item.dialog }}</span>
            </div>
          </div>
          <div class="version-card-price" :style="{
            background: item.priceColor,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent',
          }">{{ item.price }}</div>
        </div>
      </div>
    </div>

    <!-- 表格板块 -->
    <div class="table-header" ref="tableHeader">
      <div class="header-content" style="width: 1280px; display: flex;">
        <table class="price-table">
          <thead>
            <tr>
              <th>
                <div class="th-title">按需选择版本</div>
                <div class="th-desc">阶梯式方案灵活选，随需而变 高效赋能不同规模企业</div>
              </th>
              <th>
                <div class="th-visible">零售版</div>
                <div class="th-price">￥4900/年</div>
              </th>
              <th>
                <div class="th-visible">基础版</div>
                <div class="th-price">￥8900/年</div>
              </th>
              <th>
                <div class="th-visible">企业版</div>
                <div class="th-price">￥16800/年</div>
              </th>
              <th>
                <div class="th-visible">旗舰版</div>
                <div class="th-price">￥29800/年</div>
              </th>
              <th>
                <div class="th-visible">大客户版</div>
                <div class="th-price">￥39800/年</div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
    <div class="table-box" ref="tableBox">
      <table class="price-table">
        <thead>
          <tr>
            <th v-for="(col, idx) in tableHeader" :key="idx">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rIdx) in tableData" :key="rIdx">
            <td v-for="(cell, cIdx) in row" :key="cIdx">
              <template v-if="cell === true">
                <img :src="tickIcon" alt="勾" class="icon-tick" />
              </template>
              <template v-else-if="cell === false">
                <img :src="poorIcon" alt="差" class="icon-poor" />
              </template>
              <template v-else>
                {{ cell }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 量身订制板块 -->
    <div class="custom-made">
      <div class="custom-made-content">
        <div class="title-box gsap-fade-down">
          <div class="title_text">
            支持量身定制智能客服
          </div>
          <div class="title_line">
            为您的独特业务场景量身打造智能客服中枢，突破标准化限制，释放无限服务潜能
          </div>
        </div>
        <div class="card-box">
          <div class="custom-card" v-for="(item, idx) in customCardList" :key="idx">
            <div class="custom-card-content">
              <div class="custom-card-title" v-html="item.title"></div>
              <div class="custom-card-desc">{{ item.desc }}</div>
            </div>
            <div class="custom-card-img">
              <img :src="item.img" :alt="item.alt" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 统计板块 -->
    <div class="statistics-section gsap-fade-up">
      <div class="statistics-inner">
        <div class="statistics-item gsap-fade-up" v-for="item in statisticsList" :key="item.title">
          <img :src="item.icon" :alt="item.title" class="statistics-icon" />
          <div class="statistics-info">
            <div class="statistics-value">{{ item.currentValue }}<span v-if="item.title !== '注册用户'">{{ item.title ===
              '问题处理率' || item.title === '客户满意度' || item.title === '释放人力' ? '%' : '' }}</span><span
                v-if="item.title === '注册用户'">+</span></div>
            <div class="statistics-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 统计板块结束 -->
  </div>
</template>

<script>
import versionImg1 from '../../assets/img/price/pc/version_img1.png'
import versionImg2 from '../../assets/img/price/pc/version_img2.png'
import versionImg3 from '../../assets/img/price/pc/version_img3.png'
import versionImg4 from '../../assets/img/price/pc/version_img4.png'
import versionImg5 from '../../assets/img/price/pc/version_img5.png'
import fireIcon from '../../assets/img/price/pc/fire_icon.png'
import robotIcon1 from '../../assets/img/price/pc/robot_icon1.png'
import robotIcon2 from '../../assets/img/price/pc/robot_icon2.png'
import robotIcon3 from '../../assets/img/price/pc/robot_icon3.png'
import robotIcon4 from '../../assets/img/price/pc/robot_icon4.png'
import robotIcon5 from '../../assets/img/price/pc/robot_icon5.png'

import tickIcon from '../../assets/img/price/pc/tick_icon.png'
import poorIcon from '../../assets/img/price/pc/poor_icon.png'

import statisticscon1 from '../../assets/img/product/pc/statistics_icon1.png'
import statisticscon2 from '../../assets/img/product/pc/statistics_icon2.png'
import statisticscon3 from '../../assets/img/product/pc/statistics_icon3.png'
import statisticscon4 from '../../assets/img/product/pc/statistics_icon4.png'

import customImg1 from '../../assets/img/price/pc/custom_img1.png'
import customImg2 from '../../assets/img/price/pc/custom_img2.png'
import customImg3 from '../../assets/img/price/pc/custom_img3.png'

// 新增：引入gsap和ScrollTrigger
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)


export default {
  name: 'ProductIntroPC',
  data() {
    return {
      //版本
      versionImg1,
      versionImg2,
      versionImg3,
      versionImg4,
      versionImg5,
      fireIcon,
      robotIcon1,
      robotIcon2,
      robotIcon3,
      robotIcon4,
      robotIcon5,

      versionList: [
        {
          img: versionImg1,
          desc: '适合小微商家及个体经营者，轻量高效解决常见客户咨询，助您快速起步，专注核心业务。',
          descColor: '#1A3A64',
          infoBg: '#D0E2FF',
          robotIcon: robotIcon1,
          robot: '机器人工作台5个',
          dialog: '每月赠送对话条数2.5万条',
          price: '￥4900/年',
          priceColor: 'linear-gradient(35.7deg, #5495FF 0%, #043EC6 100%)',
          className: 'version-card-retail'
        },
        {
          img: versionImg2,
          desc: '适合中小企业及初创团队，自动化处理高频客服需求，显著提升响应效率，实现降本增效。',
          descColor: '#2B5183',
          infoBg: '#D0F0FF',
          robotIcon: robotIcon2,
          robot: '机器人工作台10个',
          dialog: '每月赠送对话条数8万条',
          price: '￥8900/年',
          priceColor: 'linear-gradient(35.7deg, #3B84BB 0%, #245C81 100%)',
          className: 'version-card-basic'
        },
        {
          img: versionImg3,
          desc: '适合中大型企业及复杂业务场景，提供深度定制与全渠道智能客服平台，满足个性化需求，提升服务效能与客户满意度。',
          descColor: '#845028',
          infoBg: '#FFE8D9',
          robotIcon: robotIcon3,
          robot: '机器人工作台20个',
          dialog: '每月赠送对话条数16万条',
          price: '￥16800/年',
          priceColor: 'linear-gradient(35.7deg, #AC7159 0%, #683D2A 100%)',
          className: 'version-card-enterprise'
        },
        {
          img: versionImg4,
          desc: '适合集团型公司及大型组织，构建集团级智能客服中枢，实现统一管控、高级分析与安全保障，保障业务连续性与数据合规。',
          descColor: '#7D4E2A',
          infoBg: '#FFECD0',
          robotIcon: robotIcon4,
          robot: '机器人工作台50个',
          dialog: '每月赠送对话条数40万条',
          price: '￥29800/年',
          priceColor: 'linear-gradient(35.7deg, #CF9356 0%, #834E1C 100%)',
          className: 'version-card-flagship'
        },
        {
          img: versionImg5,
          desc: '专为超大型组织及复杂业务体量设计，提供开箱即用的超大规模智能客服中枢，内置顶级安全架构与专属支持团队，确保高并发稳定运行与核心业务零风险。',

          descColor: '#2E3195',
          infoBg: '#D6D0FF',
          robotIcon: robotIcon5,
          robot: '机器人工作台100个',
          dialog: '每月赠送对话条数60万条',
          price: '￥39800/年',
          priceColor: 'linear-gradient(35.7deg, #7375D0 0%, #2B0E6F 100%)',
          className: 'version-card-vip'
        }
      ],

      // 表格
      tickIcon,
      poorIcon,
      tableHeader: [
        '版本功能清单', '零售版', '基础版', '企业版', '旗舰版', '大客户版'
      ],
      tableData: [
        ['机器人工作台数量', '5个机器人工作台', '10个机器人工作台', '20个机器人工作台', '50个机器人工作台', '100个机器人工作台'],
        ['额外增加机器人费用', false, '800元/个/年', '800元/个/年', '600元/个/年', '600元/个/年'],
        ['专业技术支持', true, true, true, true, true],
        ['赠送对话条数', '2.5万条/月', '8万条/月', '16万条/月', '40万条/月', '60万条/月'],
        ['智能回复', true, true, true, true, true],
        ['产品训练', true, true, true, true, true],
        ['数据统计分析', true, true, true, true, true],
        ['智能质检', true, true, true, true, true],
        ['人机协同', true, true, true, true, true],
        ['自主学习', true, true, true, true, true],
        ['话术优化建议', false, true, true, true, true],
        ['跨店铺知识库共享', false, false, false, true, true],
        ['AI训练中心', false, false, false, true, true],
        ['实时监控大屏', false, false, false, true, true],
      ],

      statisticscon1,
      statisticscon2,
      statisticscon3,
      statisticscon4,
      // 统计数据
      statisticsList: [
        { title: '注册用户', value: 3000, icon: statisticscon1, currentValue: 0 },
        { title: '问题处理率', value: 95, icon: statisticscon2, currentValue: 0 },
        { title: '释放人力', value: 60, icon: statisticscon3, currentValue: 0 },
        { title: '客户满意度', value: 98.5, icon: statisticscon4, currentValue: 0 }
      ],
      // 量身订制卡片数据
      customCardList: [
        {
          title: '私有化部署<br>企业级数据主权与安全闭环',
          desc: '智能客服本地化部署，实现核心数据物理隔离与全生命周期管控，满足金融、政务等高敏行业严苛合规要求',
          img: customImg1,
          alt: '私有化部署'
        },
        {
          title: '专属算法优化<br>垂直场景驱动的AI模型调优',
          desc: '基于行业知识库与业务规则强化训练NLP引擎，优化容错机制，显著提升意图识别精度（95%→99.5%）并降低转人工率。',
          img: customImg2,
          alt: '专属算法优化'
        },
        {
          title: 'ERP系统对接<br>业服一体化深度集成方案',
          desc: '通过API网关与中间件实现智能客服与主流ERP实时双向贯通，自动同步订单等数据，赋能客服全链路闭环管理。',
          img: customImg3,
          alt: 'ERP系统对接'
        }
      ]
    }
  },
  methods: {
    handleScroll() {
      const tableBox = this.$refs.tableBox;
      const tableHeader = this.$refs.tableHeader;

      if (tableBox && tableHeader) {
        const tableRect = tableBox.getBoundingClientRect();
        const navbarHeight = 64;
        const tableTop = tableRect.top;
        const tableBottom = tableRect.bottom;
        // const viewportHeight = window.innerHeight;

        // 当表格头部进入导航栏下方，且表格底部还未完全滚出视图时显示固定表头
        if (tableTop < navbarHeight && tableBottom > navbarHeight) {
          tableHeader.classList.add('visible');
          console.log('显示表头', { tableTop, navbarHeight, tableBottom });
        } else {
          tableHeader.classList.remove('visible');
          console.log('隐藏表头', { tableTop, navbarHeight, tableBottom });
        }
      }
    },

    animateNumber(idx, target, duration = 1000) {
      const start = 0;
      const isPercent = target <= 100;
      const end = target;
      const startTime = performance.now();
      const step = (now) => {
        const elapsed = now - startTime;
        let progress = Math.min(elapsed / duration, 1);
        let value = start + (end - start) * progress;
        if (isPercent) {
          value = Math.round(value * 10) / 10;
        } else {
          value = Math.floor(value);
        }
        this.$set(this.statisticsList, idx, {
          ...this.statisticsList[idx],
          currentValue: value
        });
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          this.$set(this.statisticsList, idx, {
            ...this.statisticsList[idx],
            currentValue: end
          });
        }
      };
      requestAnimationFrame(step);
    }
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);

    if (gsap && gsap.utils && gsap.fromTo) {
      // // 版本卡片错峰动画
      // gsap.utils.toArray('.version-card').forEach((el, i) => {
      //   gsap.fromTo(el,
      //     { y: 60, opacity: 0 },
      //     {
      //       y: 0,
      //       opacity: 1,
      //       duration: 0.8,
      //       delay: i * 0.15,
      //       ease: "power2.out",
      //       scrollTrigger: {
      //         trigger: el,
      //         start: "top 85%",
      //         toggleActions: "play none none reverse"
      //       }
      //     }
      //   );
      // });
      // 量身订制卡片弹性动画
      // gsap.utils.toArray('.custom-card').forEach((el, i) => {
      //   gsap.fromTo(el,
      //     { scale: 0.8, opacity: 0, y: 60 },
      //     {
      //       scale: 1, opacity: 1, y: 0,
      //       duration: 0.9, delay: i * 0.12,
      //       ease: "elastic.out(1, 0.6)",
      //       scrollTrigger: {
      //         trigger: el,
      //         start: "top 90%",
      //         toggleActions: "play none none reverse"
      //       }
      //     }
      //   );
      // });
      // 统计板块数字动画
      ScrollTrigger.create({
        trigger: '.statistics-section',
        start: 'top 80%',
        once: true,
        onEnter: () => {
          this.statisticsList.forEach((item, idx) => {
            this.animateNumber(idx, item.value, 1200);
          });
        }
      });
      // 其他动画
      gsap.utils.toArray('.gsap-fade-up').forEach(el => {
        gsap.fromTo(el,
          { y: 60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      gsap.utils.toArray('.gsap-fade-left').forEach(el => {
        gsap.fromTo(el,
          { x: -100, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      gsap.utils.toArray('.gsap-fade-right').forEach(el => {
        gsap.fromTo(el,
          { x: 100, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      gsap.utils.toArray('.gsap-fade-down').forEach(el => {
        gsap.fromTo(el,
          { y: -60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped lang="scss">
.page-content-pc {
  margin-top: 64px;
  width: 100%;
  min-width: max-content;

  .banner {
    height: 520px;
    margin: 0 auto;
    text-align: center;
    background: url('../../assets/img/price/pc/banner.png') no-repeat center center;
    background-size: cover;

    .introduce {
      width: 1280px;
      margin: 0 auto;
      padding-top: 68px;

      .introduce_title {
        font-weight: 800;
        font-size: 44px;
        color: #1D203D;
      }

      .introduce_desc {
        font-weight: 500;
        font-size: 24px;
        color: #1D203D;
        margin-top: 12px;
      }
    }
  }

  //版本板块
  .version-box {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 40px;
    margin-top: -295px;

    .version-card {
      width: 244px;
      height: 348px;
      padding: 0 9px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      position: relative;
      transition: box-shadow 0.2s;
      box-shadow: 0 4px 20px 0 rgba(17, 30, 61, 0.04);

      .version-card-desc {
        font-weight: 500;
        font-size: 14px;
        word-break: break-all;
        margin-top: 115px;
        flex: 1 1 auto;
      }

      .version-card-bottom {
        width: 100%;
      }

      .version-card-info {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        border-radius: 8px;
        padding: 6px 0 6px 16px;
        box-sizing: border-box;

        .version-card-info-item {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 13px;
          gap: 6px;

          .version-card-info-icon {
            width: 22px;
            height: 22px;
            object-fit: contain;
          }
        }
      }

      .version-card-price {
        width: 100%;
        text-align: center;
        font-weight: 800;
        font-size: 28px;
        line-height: 28px;
        margin: 12px 0;
      }
    }
  }

  // 表格板块
  .table-header {
    width: 100%;
    height: 100px;
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(134, 134, 134, 0.25);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #E6E6E6;
    // padding: 18px 0;
    position: fixed;
    top: 64px;
    left: 0;
    z-index: 10;
    opacity: 1;
    visibility: hidden;
    transition: opacity 0.3s, visibility 0.3s;
    display: flex;
    justify-content: center;

    &.visible {
      opacity: 1;
      visibility: visible;
    }

    .price-table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      font-size: 16px;
      text-align: center;
      background: #fff;

      thead tr {
        height: 75px;
      }

      th {
        width: 16.666%;
        font-weight: 800;
        font-size: 16px;

        .th-title {
          font-weight: 800;
          font-size: 20px;
          color: #333333;
          margin-bottom: 5px;
        }

        .th-desc {
          font-weight: 500;
          font-size: 14px;
          color: #666666;
        }

        .th-visible {
          font-weight: 800;
          font-size: 20px;

        }

        .th-price {
          font-weight: 800;
          font-size: 20px;
        }
      }

      th:nth-child(2) {
        background: linear-gradient(180deg, #5495FF 0%, #043EC6 100%);
        text-transform: none;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;

      }

      th:nth-child(3) {
        color: #0AADFF;
        background: linear-gradient(180deg, #3B84BB 0%, #245C81 100%);
        text-transform: none;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
      }

      th:nth-child(4) {
        color: #E3784D;
        background: linear-gradient(180deg, #AC7159 0%, #683D2A 100%);
        text-transform: none;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
      }

      th:nth-child(5) {
        color: #D48F37;
        background: linear-gradient(180deg, #CF9356 0%, #834E1C 100%);
        text-transform: none;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
      }

      th:nth-child(6) {
        color: #4E15CB;
        background: linear-gradient(180deg, #7375D0 0%, #2B0E6F 100%);
        text-transform: none;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
      }
    }
  }

  .table-box {
    width: 1280px;
    margin: 75px auto 86px auto;
    border: 1px solid #E5EAF3;

    .price-table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      font-size: 16px;
      text-align: center;
      background: transparent;
      border-radius: 12px;
      overflow: hidden;

      thead tr {
        height: 75px;
      }

      thead th {
        font-weight: 800;
        font-size: 16px;
        border-bottom: 1px solid #E5EAF3;
        border-right: 1px solid #E5EAF3;
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 2;
      }

      th:nth-child(1) {
        color: #333333;
        font-weight: 800;
        font-size: 20px;


      }

      th:nth-child(2) {
        color: #0051FF;
      }

      th:nth-child(3) {
        color: #0AADFF;
      }

      th:nth-child(4) {
        color: #E3784D;
      }

      th:nth-child(5) {
        color: #D48F37;
      }

      th:nth-child(6) {
        color: #4E15CB;
      }

      th:last-child {
        border-right: none;
      }

      td {
        height: 75px;
        border-bottom: 1px solid #E5EAF3;
        border-right: 1px solid #E5EAF3;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        vertical-align: middle;
        padding: 0 8px;
      }

      td:last-child {
        border-right: none;
      }

      tr:last-child td {
        border-bottom: none;
      }

      .icon-tick,
      .icon-poor {
        width: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  // 量身订制板块
  .custom-made {
    width: 100%;
    height: 574px;
    background: url('../../assets/img/price/pc/custom_made_bg.png') no-repeat center center;
    background-size: cover;

    .custom-made-content {
      width: 1280px;
      margin: 0 auto;

      .title-box {
        display: flex;
        flex-wrap: wrap;
        text-align: center;

        .title_text {
          width: 100%;
          display: inline-block;
          font-weight: 800;
          font-size: 48px;
          font-style: normal;
          text-transform: none;
          background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
          margin-bottom: 16px;
          margin-top: 80px;
        }

        .title_line {
          width: 100%;
          font-weight: 500;
          font-size: 24px;
          color: #333333;
          font-style: normal;
          text-transform: none;
        }
      }

      .card-box {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 32px;
        margin-top: 48px;

        .custom-card {
          width: 404px;
          height: 234px;
          background: linear-gradient(180deg, #E2F0FF 0%, #FFFFFF 100%);
          border-radius: 10px;
          border: 2px solid #FFFFFF;
          padding: 39px 0 0 17px;
          display: flex;
          box-sizing: border-box;
          position: relative;
          transition: box-shadow 0.2s;

          .custom-card-content {
            flex: 1;

            .custom-card-title {
              font-weight: 800;
              font-size: 19px;
              color: #002582;
              margin-bottom: 20px;
            }

            .custom-card-desc {
              font-weight: 500;
              font-size: 14px;
              color: #6A7FB7;
              margin-right: 10px;
            }
          }

          .custom-card-img {
            width: 144px;
            height: 144px;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
  }

  // 统计板块
  .statistics-section {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 71px auto;

    .statistics-inner {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .statistics-item {
      display: flex;
      align-items: center;
      flex: 1;
      justify-content: center;
      min-width: 0;

      .statistics-icon {
        width: 100px;
        height: 80px;
        margin-right: 20px;
        object-fit: contain;
        flex-shrink: 0;
      }

      .statistics-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
      }

      .statistics-value {
        font-weight: 800;
        font-size: 32px;
        color: #000000;
        text-align: right;
      }

      .statistics-title {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        margin-top: 4px;
      }
    }
  }

}
</style>